import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import yqLogo from "../../../../assets/img/homeV2/yq-logo.png";
import NavbarLogin from "./NavbarLogin";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  /** Add/remove scrolled class based on scroll position */
  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 5);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <nav
        className={`homeNavbar ${isScrolled ? "homeNavbar--fixed" : ""}`}
        id="home-navbar"
      >
        <div className="homeNavbar__container">
          <Link to="/" className="homeNavbar__logo">
            <div className="d-flex flex-row gap-1 gap-md-3 align-items-center">
              <img
                src={yqLogo}
                alt="Yuva Quest Logo"
                className="homeNavbar__logoIcon"
              />

              <div className="d-flex align-items-center justify-content-center">
                <h1 className="homeNavbar__logoText mb-0">YUVA QUEST</h1>
              </div>
            </div>
          </Link>

          <NavbarLogin />
        </div>
      </nav>

      {/* Spacer to prevent content jump when navbar becomes fixed */}
      {isScrolled && <div className="homeNavbar__spacer" />}
    </>
  );
};
